<template>
  <div id="echart-keycloud" style="width: 100%; height: 100%"></div>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "OpinionHotWords",
  controller: "UI",
  action: "OpinionHotWords",
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
    };
  },
  mounted: function () {
    this.search();
  },
  methods: {
    search() {
      let that = this;
      let searchInfo = {
        BeginTime: new Date().format("yyyy-MM-dd 00:00"),
        EndTime: new Date().format("yyyy-MM-dd 23:59"),
      };
      console.log(searchInfo);
      new MyApis.OpinionApi()
        .GetBigDataHotWords(searchInfo)
        .then((r) => {
          r = r.data.Data;

          that.drawChart(r);
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    drawChart(data) {
      if (data) {
        // eslint-disable-next-line no-undef
        var myChart = echarts.init(document.getElementById("echart-keycloud"));
        myChart.setOption({
          series: [
            {
              type: "wordCloud",
              textStyle: {
                normal: {
                  color: function () {
                    return (
                      "rgb(" +
                      Math.round(Math.random() * 255) +
                      ", " +
                      Math.round(Math.random() * 255) +
                      ", " +
                      Math.round(Math.random() * 255) +
                      ")"
                    );
                  },
                },
              },
              data: data,
            },
          ],
        });
      }
    },
  },
};
</script>